import React, { useState, useEffect } from "react";
import Head from "../components/Head";
import Foot from "../components/Foot";

const apiUrl = process.env.REACT_APP_API_URL;

function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${apiUrl}/api/public/testimonials`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setTestimonials(data.testimonials);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Head />

      {/* Breadcrumb */}
      <section className="ak-about-hero-1">
        <img
          src="assets/img/bg/chairman-bg.png"
          className="about-hero-bg ak-bg object-cover"
          alt="..."
          data-swiper-parallax={1152}
        />
        <div className="container">
          <div className="about-hero-content">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p className="ak-section-subtitle animation-title" style={{ color: "white !important" }}>
                IFM Edu Academy
              </p>
              <h2 className="ak-section-title animation-title" style={{ color: "white" }}>
                Testimonials
              </h2>
            </div>
            <a href="/" className="back-btn" style={{ color: "white" }}>
              Home / Testimonials
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <div className="ak-height-125 ak-height-lg-80" />
      <section className="ifm-testimonials-section">
        <div className="container">
          {/* Section Heading */}
          <div className="text-center mb-60">
            <p className="ak-section-subtitle">What Our Students Say</p>
            <h2 className="ak-section-title">Testimonials</h2>
            <p className="ifm-testi-lead">
              We place huge value on strong relationships and have seen the benefit they bring to our students.
              Feedback is vital in helping us deliver world-class Facilities Management education.
            </p>
          </div>

          {loading ? (
            <div className="text-center py-60">
              <div className="ifm-spinner" />
            </div>
          ) : testimonials.length === 0 ? (
            <div className="text-center py-60">
              <p className="text-gray-400 text-18">No testimonials yet.</p>
            </div>
          ) : (
            <div className="ifm-testi-grid">
              {testimonials.map((t) => (
                <div key={t.id} className="ifm-testi-card">
                  {/* Avatar */}
                  <div className="ifm-testi-avatar-wrap">
                    <img
                      src={
                        t.photo
                          ? `${apiUrl}/${t.photo}`
                          : "assets/img/testimonials/default-avatar.png"
                      }
                      alt={t.name}
                      className="ifm-testi-avatar"
                    />
                  </div>

                  {/* Quote icon */}
                  <div className="ifm-testi-quote-icon">
                    <svg width="32" height="24" viewBox="0 0 32 24" fill="none">
                      <path
                        d="M0 24V14.4C0 10.08 1.12 6.56 3.36 3.84 5.6 1.12 8.96 0 13.44 0L14.4 3.36C11.84 3.68 9.92 4.64 8.64 6.24 7.36 7.84 6.72 9.76 6.72 12H13.44V24H0ZM17.28 24V14.4C17.28 10.08 18.4 6.56 20.64 3.84 22.88 1.12 26.24 0 30.72 0L31.68 3.36C29.12 3.68 27.2 4.64 25.92 6.24 24.64 7.84 24 9.76 24 12H30.72V24H17.28Z"
                        fill="#2D8653"
                        fillOpacity="0.15"
                      />
                    </svg>
                  </div>

                  {/* Quote text */}
                  <p className="ifm-testi-text">{t.testimonial}</p>

                  {/* Closing quote icon */}
                  <div className="ifm-testi-quote-close">
                    <svg width="32" height="24" viewBox="0 0 32 24" fill="none">
                      <path
                        d="M32 0V9.6C32 13.92 30.88 17.44 28.64 20.16 26.4 22.88 23.04 24 18.56 24L17.6 20.64C20.16 20.32 22.08 19.36 23.36 17.76 24.64 16.16 25.28 14.24 25.28 12H18.56V0H32ZM14.72 0V9.6C14.72 13.92 13.6 17.44 11.36 20.16 9.12 22.88 5.76 24 1.28 24L0.32 20.64C2.88 20.32 4.8 19.36 6.08 17.76 7.36 16.16 8 14.24 8 12H1.28V0H14.72Z"
                        fill="#2D8653"
                        fillOpacity="0.15"
                      />
                    </svg>
                  </div>

                  {/* Star rating */}
                  <div className="ifm-testi-stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <svg
                        key={star}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill={star <= (t.rating || 5) ? "#F5A623" : "#E0E0E0"}
                      >
                        <path d="M8 1L10.163 5.279L15 6.007L11.5 9.374L12.326 14.196L8 11.979L3.674 14.196L4.5 9.374L1 6.007L5.837 5.279L8 1Z" />
                      </svg>
                    ))}
                  </div>

                  {/* Divider */}
                  <div className="ifm-testi-divider" />

                  {/* Name & designation */}
                  <div className="ifm-testi-author">
                    <h5 className="ifm-testi-name">{t.name}</h5>
                    <span className="ifm-testi-designation">{t.designation}</span>
                    {t.company && (
                      <span className="ifm-testi-company"> · {t.company}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Background decoration */}
        <img className="aboutus" src="assets/img/bg/aboutus.png" alt="..." />
      </section>

      {/* Inline styles scoped to this page */}
      <style>{`
        .ifm-testimonials-section {
          position: relative;
          padding-bottom: 100px;
          overflow: hidden;
        }

        .ifm-testi-lead {
          max-width: 680px;
          margin: 16px auto 0;
          color: #6b7280;
          font-size: 16px;
          line-height: 1.7;
          text-align: center;
        }

        .ifm-testi-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 28px;
          margin-top: 48px;
        }

        @media (max-width: 1024px) {
          .ifm-testi-grid { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 640px) {
          .ifm-testi-grid { grid-template-columns: 1fr; }
        }

        .ifm-testi-card {
          background: #ffffff;
          border: 1px solid #e8f5ee;
          border-radius: 16px;
          padding: 36px 28px 32px;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          box-shadow: 0 4px 24px rgba(45, 134, 83, 0.07);
          transition: box-shadow 0.3s ease, transform 0.3s ease;
        }

        .ifm-testi-card:hover {
          box-shadow: 0 12px 40px rgba(45, 134, 83, 0.14);
          transform: translateY(-4px);
        }

        .ifm-testi-avatar-wrap {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 3px solid #2D8653;
          padding: 3px;
          margin-bottom: 20px;
          background: #fff;
        }

        .ifm-testi-avatar {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
          display: block;
        }

        .ifm-testi-quote-icon {
          position: absolute;
          top: 28px;
          left: 24px;
          opacity: 0.7;
        }

        .ifm-testi-quote-close {
          position: absolute;
          bottom: 100px;
          right: 24px;
          opacity: 0.7;
        }

        .ifm-testi-text {
          font-size: 15px;
          line-height: 1.75;
          color: #4b5563;
          margin: 0 0 18px;
          flex: 1;
        }

        .ifm-testi-stars {
          display: flex;
          gap: 4px;
          margin-bottom: 16px;
        }

        .ifm-testi-divider {
          width: 48px;
          height: 2px;
          background: #2D8653;
          border-radius: 2px;
          margin: 0 auto 16px;
        }

        .ifm-testi-author {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2px;
        }

        .ifm-testi-name {
          font-size: 16px;
          font-weight: 700;
          color: #2D8653;
          margin: 0;
        }

        .ifm-testi-designation {
          font-size: 13px;
          color: #6b7280;
        }

        .ifm-testi-company {
          font-size: 13px;
          color: #9ca3af;
        }

        .ifm-spinner {
          width: 44px;
          height: 44px;
          border: 4px solid #e8f5ee;
          border-top-color: #2D8653;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          margin: 0 auto;
        }

        @keyframes spin { to { transform: rotate(360deg); } }

        .mb-60 { margin-bottom: 60px; }
        .py-60 { padding-top: 60px; padding-bottom: 60px; }
        .text-18 { font-size: 18px; }
      `}</style>

      <div className="ak-height-125 ak-height-lg-80" />
      <Foot />
    </>
  );
}

export default Testimonials;
